/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageRequest
 */
export interface StorageRequest {
    /**
     * 
     * @type {string}
     * @memberof StorageRequest
     */
    value: string | null;
    /**
     * 
     * @type {string}
     * @memberof StorageRequest
     */
    initiator: string | null;
}

export function StorageRequestFromJSON(json: any): StorageRequest {
    return StorageRequestFromJSONTyped(json, false);
}

export function StorageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'initiator': json['initiator'],
    };
}

export function StorageRequestToJSON(value?: StorageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'initiator': value.initiator,
    };
}


